import React, { FunctionComponent, useCallback } from "react";
import { Form, FloatingLabel } from "react-bootstrap";

import countryCodes from "../codes";

type CountryCodeProps = {
  value: string;
  setValue: (code: string) => any;
};

const CountryCodeComponent: FunctionComponent<CountryCodeProps> = ({ value, setValue }) => {
  const onChange = useCallback<React.ChangeEventHandler<HTMLSelectElement>>((e) => setValue(e.target.value), [setValue]);

  return (
    <FloatingLabel label="Country Code">
      <Form.Select name="contact" value={value} onChange={onChange}>
        {countryCodes.map(([code, name]) => (
          <option key={code} value={code}>
            {name}
          </option>
        ))}
      </Form.Select>
    </FloatingLabel>
  );
};

export default React.memo(CountryCodeComponent);
